import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addPersonalSkillsAction,
    updatePersonalSkillsAction,
    deletePersonalSkillsAction
} from '../../../redux/actions/admin/adminAction';

export const PersonalSkills = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'personal_skill': '', 'score': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'personal_skill': '', 'score': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updatePersonalSkills(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addPersonalSkills(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deletePersonalSkills(id)
    }

    const [personalColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Personal Skill", field: 'personal_skill', filter: true, },
        { headerName: "Score", field: 'score', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.personalSkills}
                defaultColDef={defaultColDef}
                columnDefs={personalColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Personal Skills</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Personal Skill</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="personal_skill"
                                name="personal_skill"
                                value={inputData.personal_skill}
                                onChange={handleChange}
                                placeholder="Personal Skill"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const personalSkills = state.admin.personalSkills;
    return {
        personalSkills: personalSkills,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addPersonalSkills: (data) => dispatch(addPersonalSkillsAction(data)),
        updatePersonalSkills: (id, data) => dispatch(updatePersonalSkillsAction(id, data)),
        deletePersonalSkills: (id) => dispatch(deletePersonalSkillsAction(id)),
    };
};



export default connect(mapStateToProps, mapDispatchToProps)(PersonalSkills)

